import slice from './dataModelerSlice';

export * from './types';
export const {
  dataModelerDiscardCurrentEdits,
  dataModelerToggleExpandTable,
  dataModelerSetCurrentSchemaId,
  dataModelerSetSchemaDataModel,
  dataModelerCreateDraftSchema,
  dataModelerSetSchemaDisabled,
  dataModelerUpdateCurrentSchemaName,
  dataModelerUpdateCurrentSchemaDescription,
  dataModelerSetSamplingConfig,
  dataModelerUpdateDataSource,
  dataModelerUpdateEndDateConfig,
  dataModelerUpdateJoinData,
  dataModelAddDraftFactTableData,
  dataModelSetDraftFactTableAutoMapped,
  dataModelerSetEventColumn,
  dataModelerSetDraftSubject,
  dataModelerSetDraftSubjectName,
  dataModelerRemoveDraftSubject,
  dataModelerExtendFactSubject,
  dataModelerSetEventTemporalColumn,
  dataModelerAddDraftInstallTemporals,
  dataModelerRemoveDraftInstallTemporals,
  dataModelerSetInstallTemporalColumn,
  dataModelerAddDraftDimensionData,
  dataModelerHandleRemoveDraftTableData,
  dataModelerAddDraftFieldData,
  dataModelerSwitchDraftFieldToExtendInput,
  dataModelerUpdateExtendFieldTypeInput,
  dataModelerSwitchDraftFieldToAddInput,
  dataModelerRemoveDraftFieldData,
  dataModelerUpdateDraftFieldData,
  dataModelerAddDraftDerivedField,
  dataModelerRemoveDraftDerivedField,
  dataModelerUpdateDraftDerivedField,
  dataModelerSetUiDraftDerivedField,
  dataModelerUpdateExistingFieldInput,
  dataModelerEditExistingDerivedColumnInput,
  dataModelerEditDraftDerivedColumnInput,
  dataModelerAddDraftFunnelPartitionField,
  dataModelerRemoveDraftFunnelPartitionField,
  dataModelerUpdateDraftFunnelPartitionName,
  dataModelerUpdateDataRefreshConfig,
  dataModelerSetUpdateInProgress,
  dataModelerSetLockedTtlSeconds,
  dataModelerSetDerivedColumnDraft,
  dataModelerSetDerivedColumnEdit,
} = slice.actions;

export default slice.reducer;
